<template>
  <div>
    <component v-if="view" :is="view" :hotel="hotel" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
/**
 * Componente que verifica o tipo de tarifa e renderiza a view correta
 */
export default {
  name: 'Base',
  components: {
    pointsUpdate: () =>
      import(/* webpackPrefetch: true */ '../points/pointsUpdate/index.vue')
  },
  data() {
    return {
      view: null,
      hotel: {}
    }
  },
  created() {
    /** Retorna dados do hotel selecionado e define o pointsUpdate como a view do componente */
    this.requestHotelConfigs(this.$route.params.id).then((response) => {
      this.hotel = response || {}

      this.view = 'pointsUpdate'
    })
  },
  methods: {
    ...mapActions('hotel', ['requestHotelConfigs'])
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}
</style>
